import React from 'react';
import styled from 'styled-components';
import { PrismicRichText } from '@prismicio/react';

const StyledWebinarOverview = styled.div`
  display: flex;
  justify-content: center;
  padding: 4rem 2rem;
  gap: 6rem;

  ul {
    margin: 0;
    padding-left: 1.2rem;
  }

  .what-to-expect,
  .topics {
    flex: 1;
    max-width: 28.9375rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    h3 {
      text-transform: uppercase;
      color: var(--primary);
    }
  }

  @media (max-width: 1100px) {
    padding: 4rem;
  }

  @media (max-width: 800px) {
    flex-direction: column;
    gap: 3rem;
    padding: 1.5rem;

    .what-to-expect,
    .topics {
      max-width: none;
    }
  }
`;

const WebinarOverview = ({ whatToExpect, topics }) => {
  return (
    <StyledWebinarOverview>
      <div className="what-to-expect">
        <h3 className="heading-m-semibold">What To Expect</h3>
        <PrismicRichText
          field={whatToExpect}
          components={{
            paragraph: ({ children }) => <p className="body-m-regular">{children}</p>,
          }}
        />
      </div>
      <div className="topics">
        <h3 className="heading-m-semibold">Topics We'll Dive Into</h3>
        <ul>
          {topics.map((topic, idx) => {
            return (
              <li className="body-m-regular" key={idx}>
                {topic}
              </li>
            );
          })}
        </ul>
      </div>
    </StyledWebinarOverview>
  );
};

export default WebinarOverview;
